import { config } from 'lib/config'

export const getJobsPortalUrl = () => `https://jobs.${config.API_BASE_URL}/jobs`
